export { SeoPageSchema } from './SeoPageSchema';
